var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.499756,
    height: 17.497925,
    viewBox: "0 0 17.4998 17.4979",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.75 11.75L11.75 5.75M7.75 2.75L8.21 2.21C9.15 1.27 10.42 0.74 11.74 0.75C13.07 0.75 14.34 1.27 15.28 2.21C16.22 3.15 16.75 4.42 16.74 5.75C16.74 7.07 16.22 8.34 15.28 9.28L14.75 9.75M9.75 14.75L9.35 15.28C8.4 16.22 7.12 16.74 5.79 16.74C4.45 16.74 3.17 16.22 2.22 15.28C1.75 14.82 1.38 14.27 1.13 13.66C0.88 13.05 0.75 12.4 0.75 11.74C0.75 11.09 0.88 10.43 1.13 9.83C1.38 9.22 1.75 8.67 2.22 8.21L2.75 7.75",
    stroke: "#7252DC",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.b2b21672c9039ff35274bb09d204965d.svg";
export { ForwardRef as ReactComponent };